import { ChangeEvent } from 'react';
import { useStepEditor } from 'sequential-workflow-designer-react';

export function ExternalStepEditor() {
	const { name, setName } = useStepEditor();

	function onNameChanged(e: ChangeEvent) {
		setName((e.target as HTMLInputElement).value);
	}

	return (
		<>
			<h2>Step Editor</h2>

			<h4>Name</h4>
			<input type="text" value={name} onChange={onNameChanged} />
		</>
	);
}
